import { render, staticRenderFns } from "./Wangeditor.vue?vue&type=template&id=6ec070be&scoped=true&"
import script from "./Wangeditor.vue?vue&type=script&lang=js&"
export * from "./Wangeditor.vue?vue&type=script&lang=js&"
import style0 from "./Wangeditor.vue?vue&type=style&index=0&id=6ec070be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec070be",
  null
  
)

export default component.exports